import React from "react";
import Icon from "../../libraries/icons";
import { uuidv4, isFunction, capitalize, } from "../../libraries/utils";
import { useTranslation } from "react-i18next";

export default function ChatBubbleElement({ messages, actions, left, ...rest }) {
  const { t, i18n } = useTranslation();


  return (
    <div key={rest.key || uuidv4()}>
      <div className="flex">
        <div className="mr-3">
          {/* {messages.patient.profile_image && <img src={messages.patient.profile_image} className="rounded-full w-12 h-12" alt="profile img" />} */}
        </div>
        <div className="w-full">
          <div className="flex justify-between leading-tight">
            <div className="mb-4">
              {/* {messages.patient.json_data.first_name && (
                <h3 className="text-primary">{capitalize(messages.patient.json_data.first_name)} {capitalize(messages.patient.json_data.last_name)}</h3>
              )} */}
            </div>
            <p>{messages.body}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
